import React from "react";
import * as dc from "dc";
import { ChartTemplate } from "./chartTemplate";
import * as d3 from "d3";
import * as crossfilter from "crossfilter2/crossfilter";

const diverseEconoChartFunc = (divRef, ndx) => {
    let compositeChart = dc.compositeChart(divRef);
    // custom reducer function

    const divesity_by_gender = ndx.dimension((d) => d.gender);


  const grp = divesity_by_gender.group().reduce(
    /* callback for when data is added to the current filter results */
      (p, v) => {
          ++p.count
          p.totalDEO += v.totalDEOPercent;
          p.youthDEO += v.youthDEOPercent;
          p.avg_totalDEO = (p.totalDEO / p.count)*100 // convert back to %
          p.avg_youth = (p.youthDEO / p.count)*100 // convert back to %
      return p;
    },
    /* callback for when data is removed from the current filter results */
      (p, v) => {
          --p.count
          p.totalDEO -= v.totalDEOPercent;
          p.youthDEO -= v.youthDEOPercent;
          p.avg_totalDEO = (p.totalDEO / p.count)* 100 // convert back to percentage
          p.avg_youth = (p.youthDEO / p.count) * 100 // convert back to percentage
      return p;
    },
    /* initialize p */
    () => ({totalDEO: 0, youthDEO: 0, count: 0, avg_totalDEO: 0, avg_youth:0})
  );
  // console.log(grp.top(Infinity));
  // const population_dist_grp = regroup(pop_by_gender, ["totalPop", "youthpop"]);

  const BAR_PADDING = 0.1; // percentage the padding will take from the bar
  const RANGE_BAND_PADDING = 0.2; // padding between 'groups'
  const OUTER_RANGE_BAND_PADDING = 0.2; // padding from each side of the chart

  let sizing = (chart) => {
    chart.width(window.innerWidth).height(window.innerHeight).redraw();
  };

  let resizing = (chart) => (window.onresize = () => sizing(chart));

  let barPadding;
  let scaleSubChartBarWidth = (chart) => {
    let subs = chart.selectAll(".sub");

    if (typeof barPadding === "undefined") {
      // first draw only
      // to percentage
      barPadding = (BAR_PADDING / subs.size()) * 100;
      // each bar gets half the padding
      barPadding = barPadding / 2;
    }

    let startAt,
      endAt,
      subScale = d3.scaleLinear().domain([0, subs.size()]).range([0, 100]);

    subs.each(function (d, i) {
      startAt = subScale(i + 1) - subScale(1);
      endAt = subScale(i + 1);

      startAt += barPadding;
      endAt -= barPadding;

      d3.select(this)
        .selectAll("rect")
        .attr(
          "clip-path",
          `polygon(${startAt}% 0, ${endAt}% 0, ${endAt}% 100%, ${startAt}% 100%)`
        );
    });
  };
      function remove_empty_bins(source_group, key_to_remove) {
        return {
          all: function () {
            return source_group.all().filter(function (d) {
              return d.key !== key_to_remove;
            });
          },
        };
      }
    var resulting_bins = remove_empty_bins(grp, null); // remove empty bins
    var f = d3.format(",.1f"); // create a formating functions
   
    let barChart1 = dc
        .barChart(compositeChart) // pass the parent chart
        .barPadding(0)
   
        .on("pretransition  ", function (chart) {
            chart.valueAccessor((d) => {
               
               return d.value["totalDEO"]
            });

        })
        .valueAccessor((d) => {
            return d.value["avg_totalDEO"];
        })
        .title((d) => d.key + ` : ${f(d.value["avg_totalDEO"])} %`)
        .colors(["#F6CA5F"]);



    let barChart2 = dc
        .barChart(compositeChart) // pass the parent chart
        .barPadding(0)

        .on("pretransition  ", function (chart) {
            chart.valueAccessor((d) => {

                return d.value["youthDEO"]
            });
        })
        .valueAccessor((d) => {

            return d.value["avg_youth"]
        } )
        .title((d) => d.key + ` : ${f(d.value["avg_youth"])} %`)
        .colors(["#80AED5"]);


  compositeChart
    .shareTitle(false)
    .dimension(divesity_by_gender)
    .width(280)
    .height(150)
      .elasticY(true)
    // .margins({ bottom: 0 })
      .group(resulting_bins)
      .transitionDuration(1500)
    // .margins({ bottom: 20 })
    .legend(dc.legend().x(65).y(170).itemHeight(10).gap(10).horizontal(true))
    ._rangeBandPadding(RANGE_BAND_PADDING) // define inner padding between the bars
      ._outerRangeBandPadding(OUTER_RANGE_BAND_PADDING) // define bar's outer padding
    .x(d3.scaleOrdinal())
    .xUnits(dc.units.ordinal)
    .compose([
      barChart1.group(resulting_bins, "Total"), // pass the bar charts to the composite chart
      barChart2.group(resulting_bins, "Youth"),
    ])
    .on("pretransition", (chart) => {
      scaleSubChartBarWidth(chart);
    })
    .on("filtered", (chart, filter) => {
      console.log(chart, filter);
    })
    .on("preRedraw", (chart) => {
      chart.rescale();
    })
    .on("preRender", (chart) => {
      chart.rescale();
    });
  compositeChart.xAxis().tickFormat(function (v) {
    if (v == "Female") {
      return "Female";
    } else if (v == "Male") {
      return "Male";
    }
  });
  compositeChart.yAxis().ticks(0);
  return compositeChart;
};

export const DiverseEconomicActivitiesChart = (props) => (
  <ChartTemplate
    chartFunction={diverseEconoChartFunc}
    title="Population Near Diverse Economic Activities"
  />
);
